<div class="dropzone" [class.compact]="tiivis" [class.is-drag]="raahaus" (dragover)="kasitteleTiedostojenRaahausYli($event)" (dragleave)="kasitteleTiedostojenRaahausPois()" (drop)="kasitteleTiedostojenPudotus($event)">
  <div [class.text]="tiivis">
    @if (tiivis) {
      <h3>{{ 'tositteet.lisaa-tositteita.tosite-pudotusalue.tiivis-otsikko' | translate | async }}</h3>
      <p>{{ 'tositteet.lisaa-tositteita.tosite-pudotusalue.tiivis-teksti' | translate | async }}</p>
    } @else {
      <h3>{{ 'tositteet.lisaa-tositteita.tosite-pudotusalue.otsikko' | translate | async }}</h3>
      <p>{{ 'tositteet.lisaa-tositteita.tosite-pudotusalue.teksti' | translate | async }}</p>
    }
  </div>

  <button class="primarybutton" type="button" (click)="avaaTiedostonValinta()" [attr.aria-label]="'tositteet.lisaa-tositteita.tosite-pudotusalue.valitse-tiedostot-aria' | translate | async">
    {{ 'tositteet.lisaa-tositteita.tosite-pudotusalue.valitse-tiedostot' | translate | async }}
  </button>

  <input #tiedostoInput type="file" multiple accept="image/*,application/pdf,.heic,.heif" style="display: none" (change)="tiedostotMuuttui($event)" [attr.aria-label]="'tositteet.lisaa-tositteita.tosite-pudotusalue.tiedostovalinta-aria' | translate | async" />
</div>
